<template>
    <div class="payment-option-container">
      <!-- TODO : point -->
        <div class="input-title">쿠폰 / 적립금</div>
        <div class="option-border"></div>
        <div class="pay-option-block">
            <div class="pay-option-title">쿠폰 번호</div>
            <div class="pay-option-row">
                <input class="pay-option-input" v-model="this.coupon" type="text" placeholder="보유하신 쿠폰 번호를 입력해주세요.">
                <div><button @click="checkCoupon" class="pay-option-btn">쿠폰 적용하기</button></div>
            </div>
            <div class="pay-option-warn" id="warn" v-if="errorMsg">*유효하지 않은 쿠폰입니다.</div>
            <div class="pay-option-title">적립금</div>
            <div class="pay-option-row">
                <input class="pay-option-input" v-model="this.payPoint" type="number" placeholder="사용하려는 적립금 액수를 입력해주세요.">
                <div><button @click="usePayPoint" class="pay-option-btn">적립금 적용하기</button></div>
            </div>
            <div class="pay-option-warn">보유 적립금 {{ this.point }}원</div>
            <div class="pay-option-warn">*적립금은 결제 금액이 10,000원 이상일 때만 사용 가능하며, 주문 금액의 최대 10%까지 사용 가능합니다.</div>
      
        </div>
    
    
    </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import { showAlert } from '@/plugins/dialog'

export default {
  data(){
    return{
      coupon : '',
      payPoint : 0,
      percent : 0,
      errorMsg : false,
      point : 0,
    }
  },

  mounted(){
    this.reset()
  },

  methods : {
    async checkCoupon(){
      try {
        const response = await axios.get(`https://gosurveasy.co.kr/coupon/${this.coupon}`)
        this.percent = response.data.discountPercent
        this.errorMsg = false
        store.commit('saveSurveyPriceOption', {
          coupon : store.state.surveyOption.price * this.percent * 0.01,
          point : this.payPoint
        })
      }catch(error){
        this.errorMsg = true
        store.commit('saveSurveyPriceOption', {
          coupon : 0,
          point : this.payPoint
        })
      }
      
    },

    reset(){
      store.commit('saveSurveyPriceOption', {
          coupon : 0,
          point : 0
        })
    },

    async usePayPoint(){
      const price = store.state.surveyOption.price
      if(this.payPoint > price * 0.1 || price < 10000){
        await showAlert("적립금은 결제 금액이 10,000원 이상일 때만 사용 가능하며, 결제 금액의 최대 10%까지 사용 가능합니다.")
      }else if(this.point < this.payPoint){
        await showAlert("보유하신 적립금을 초과하여 입력하셨습니다.")
      }else{
        store.commit('saveSurveyPriceOption', {
          coupon : store.state.surveyOption.coupon,
          point : this.payPoint
        })
      }
      
    }
  }

}
</script>

<style scoped>
.payment-option-container{
  display: flex;
  flex-direction: column;
  font-family: var(--font-sans);
  text-align: left;
  max-width: 552px;
  margin: 24px auto;
  padding: 24px;
  box-sizing: border-box;
  background-color: var(--surface-card);
  border: 1px solid var(--ink-100);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-md);
}
.input-title{
  font-size: 18px;
  font-weight: var(--font-weight-semibold);
  color: var(--ink-900);
}
.option-border{
  border-top: 1px solid var(--ink-200);
  margin-top: 14px;
}
.pay-option-row{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: left;
    gap: 8px;
}
.pay-option-block{
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  justify-content: left;
}
.payment-option-container .pay-option-input {
  box-sizing: border-box;
  margin-top: 8px;
  width: 100%;
  height: 40px;
  padding: 0 12px;
  font-family: var(--font-sans);
  font-size: 14px;
  color: var(--ink-800);
  background-color: var(--white);
  border: 1px solid var(--ink-200);
  border-radius: var(--radius-md);
}
.payment-option-container .pay-option-input:focus {
  outline: none;
  border-color: var(--green-500);
}
.pay-option-warn{
  text-align: left;
  color: var(--ink-400);
  font-size: 12px;
  font-weight: var(--font-weight-regular);
  margin-top: 8px;
}
.pay-option-title{
  text-align: left;
  font-size: 14px;
  font-weight: var(--font-weight-semibold);
  color: var(--ink-800);
  margin-top: 18px;
}
.pay-option-btn {
  box-sizing: border-box;
  height: 40px;
  padding: 0 16px;
  margin-top: 8px;
  color: var(--green-600);
  background-color: var(--white);
  border: 1px solid var(--green-500);
  border-radius: var(--radius-md);
  font-size: 13px;
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  font-family: var(--font-sans);
  white-space: nowrap;
}
.pay-option-btn:hover{
  color: var(--white);
  background: var(--green-600);
  border-color: var(--green-600);
}
#warn{
  color: var(--danger-500);
}
</style>